import yup from 'src/libraries/validator.library';
import { httpClient } from 'src/libraries/http.library';
import {
  IAdminForm,
  AdminSchema,
  AdminResponsePayloadSchema,
  AdminListSchema,
} from 'src/models/admin.model';

const client = httpClient();

const services = {
  listGET: async () => {
    return client.get('users', {}, AdminListSchema);
  },

  dataGET: async (empNo: string) => {
    return client.get(`users/${empNo}`, {}, AdminSchema);
  },

  createPOST: async (data: IAdminForm) => {
    return client.post('users', data, AdminResponsePayloadSchema);
  },

  updatePUT: async (data: IAdminForm) => {
    return client.put(`users/${data.empNo}`, data, AdminResponsePayloadSchema);
  },

  dataDELETE: async (id: string) => {
    return client.delete(`users/${id}`, yup.mixed());
  },
};

export default services;
